let products_on_page = $('.products-on-page');
let next_url = products_on_page.data('next-url');
let loadMoreBtn = $('.load-more-btn');
let loadMoreSpinner = $('.load-more-spinner');
let gridItems = $('.products-on-page li.grid__item');
let gridSize = gridItems.length;
let totalGridSize = gridItems.length;
let  spanElement = $('.displayed-products');
let  spanElement2 = $('.total-items');
   // console.log('Number of li elements with class "grid__item":',gridSize );

let next_url_c = $('.products-on-page').data('next-url');
let gridItems_c = $('.products-on-page li.grid__item');
let gridSize_c = 0;
let final_gridSize_c = 0;
function loadmoreBtn(state){
   if(state=="open"){
      document.querySelector('.load-more-btn').style.display = 'block';
   }else{
      document.querySelector('.load-more-btn').style.display = 'none';
   } 
}

function loadmoreSpn(state){
   if(state=="open"){
      document.querySelector('.load-more-spinner').style.display = 'block';
   }else{
      document.querySelector('.load-more-spinner').style.display = 'none';
   
   } }

function updateProdDisplayed() {
  if (window.location.href.includes('filter')) {
        let  spanElement = document.querySelector('.displayed-products');
        let gridItems = document.querySelectorAll('.products-on-page li.grid__item');
        let gridSize = gridItems.length;
        spanElement.textContent = gridSize;
        spanElement.setAttribute('total-displayed', gridSize);
  }
  
}



function loadMoreProducts(){
     loadMoreSpinner.show();
     loadMoreBtn.hide();
     loadmoreBtn('close');
     loadmoreSpn('open');
       products_on_page = $('.products-on-page');
       next_url = products_on_page.data('next-url');
       // console.log('next url: ',next_url);
       $.ajax({
            url:next_url,
            type:'GET',
            dataType:'html',
            beforeSend:function(){
              // loadMoreSpinner.show();
              // loadMoreBtn.hide();
            }
          }).done(function(next_page){
             history.replaceState({}, '', next_url);
             let new_products = $(next_page).find('.products-on-page');
             let new_url = new_products.data('next-url');
             next_url = new_url;
             // console.log('new next_url: ',next_url);
          //   products_on_page.data('next-url', next_url);
         //    products_on_page.attr('data-next-url', next_url);
         //   console.log('products_on_page: ',products_on_page;
          //  console.log('Updated next_url:', products_on_page.data('next-url'));
          // Select the element by its id
          $('#product-grid').attr('data-next-url', next_url);


             products_on_page.append(new_products.html());
         loadmoreSpn('close');
             loadMoreSpinner.hide();
             
             if(new_url){
                // console.log('new url: ',new_url );
               loadMoreBtn.show();
               loadmoreBtn('open');
               currentUrl = window.location.href;
               localStorage.setItem(currentUrl + '-fullyloaded', false);
             }else{
               currentUrl = window.location.href;
               localStorage.setItem(currentUrl + '-fullyloaded', true);
             }
              gridItems = $('.products-on-page li.grid__item');
              gridSize = gridItems.length;
              //console.log('default number : ',gridSize);
              spanElement.text(gridSize);
              spanElement.attr('total-displayed', gridSize);
             updateProgressBar();
             setTimeout(() => {
                 var tolstoyTiles = document.querySelectorAll(".tolstoy-collection-tile");
                 tolstoyTiles.forEach(function (tile) {
                  // Check if the tile still has no child nodes after the delay
                  if (!tile.hasChildNodes()) {
                    tile.style.display = "none";
                  }
                });
               carouselifyCollectionNew();
                 updateProdDisplayed()
               }, 1000);
            
          })
}



// Function to get all products from all pages without appending to DOM
function getAllProductList() {
    let prev_url = "";
    if (!next_url_c || prev_url==next_url_c ) {
        // Stop if there's no more next URL
      // if(gridSize_c > 20){
      //   gridSize_c = gridSize_c-20;
      // }
      //   console.log("All pages loaded. Total products: " + gridSize_c);
      //   final_gridSize_c =gridSize_c;
      //   gridSize_c = 0;
        return;
    }

    // console.log('Fetching next page: ' + next_url_c);
    
    $.ajax({
        url: next_url_c,
        type: 'GET',
        dataType: 'html'
    }).done(function(next_page) {
        // Find the new products and update the next URL
        let new_products = $(next_page).find('.products-on-page');
        let new_url_c = new_products.data('next-url');
       

        // Get the new products but do not append them to the DOM
        let new_productGrid = $(next_page).find('li.grid__item');
        let gridSize_new = new_productGrid.length;
         
        // Update the total grid size
      // if (!next_url_c.includes('page')) {
      //       gridSize_c = 20;
      //   } else {
      //      
      //   }
       gridSize_c += gridSize_new;
        prev_url = next_url_c;
        next_url_c = new_url_c;
        let current_url = window.location.href;
      
        // console.log('Current total product count: ' + gridSize_c);
     
        // Recursively call the function if there's a next page
        if (next_url_c) {
            // console.log('next page to be fetch: ',next_url_c);
            getAllProductList();
        } else {
            // console.log("All pages loaded. Final total product count: " + gridSize_c);
          final_gridSize_c =gridSize_c;
          gridSize_c = 0;
           let newTextCount = "of " + gridSize_c;
          const totalItemsElement = document.querySelector('.total-items');
          if (totalItemsElement) {
            totalItemsElement.setAttribute('total-item-value', final_gridSize_c);
            totalItemsElement.textContent = `of ${final_gridSize_c}`;
          }
           updateProgressBar();
        }
    }).fail(function() {
        // console.log("Error fetching the next page.");
    });
}

function updateProgressBar() {
   // console.log('calculating progress');
  //   let displayedProducts = parseInt(document.querySelector('.displayed-products').getAttribute('total-displayed'));
  //   let totalItems = parseInt(document.querySelector('.total-items').getAttribute('total-item-value').replace('of ', ''));
    
  //   // Calculate progress percentage
  //   let progress = (displayedProducts / totalItems) * 100;
    
  //   // Update progress bar width
  //   let progressBar = document.querySelector('.progress-bar');
  //   progressBar.style.width = progress + '%';
  //   if(progress==100){
  //      document.querySelector('.load-more-btn').style.setProperty('display', 'none', 'important');
  //      currentUrl = window.location.href;
  //      localStorage.setItem(currentUrl + '-fullyloaded', true);
  //   }
  // console.log('progress calculated');
  }




function carouselifyCollectionNew() {
    // console.log("executing carouselifyCollection new.... ");
    //removeStyles();
    // Carousel init
    const collection_carousels = document.querySelectorAll('.custom.carouselOfImages');

    collection_carousels.forEach(carousel => {
        // Check if the carousel already has a Flickity instance
        if (carousel.flickity) {
            carousel.flickity('destroy'); // Destroy existing Flickity instance
        }

        // Reinitialize Flickity
        new Flickity(carousel, {
            // options go here
            cellAlign: 'left',
            contain: true,
            friction: 0.2,
            initialIndex: 0,
            pageDots: true,
            lazyLoad: false,
            wrapAround: true,
            cellSelector: '.collection-product__anchor',
            prevNextButtons: false,
        });
    });

    var tolstoyTiles = document.querySelectorAll(".tolstoy-collection-tile");

  // Delay hiding elements to allow Tolstoy to add content
  setTimeout(function() {
    tolstoyTiles.forEach(function (tile) {
      // Check if the tile still has no child nodes after the delay
      if (!tile.hasChildNodes()) {
        tile.style.display = "none";
      }
    });
  }, 3000)

    // console.log("carouselifyCollection executed new");
}

// Check if session is active or not
if (!sessionStorage.getItem('sessionActive')) {
    // Clear localStorage for a new session (new session means no 'sessionActive' found)
    let pageKey = window.location.pathname;
    let current_url = window.location.href;
    localStorage.removeItem(current_url);
    localStorage.removeItem('totalDisplayed');
    localStorage.removeItem('totalItems');
    localStorage.removeItem('selectedProduct');
    localStorage.removeItem(current_url + '-totalItems');
    localStorage.removeItem(current_url + '-totalDisplayed');
    localStorage.removeItem(current_url + '-fullyloaded');
    
    // console.log('New session started, clearing previous saved data for', current_url);
    sessionStorage.setItem('sessionActive', 'true');  // Mark the session as active

}

